module.exports = __webpack_public_path__ + "img/Pages-icon.woff?498d408ac2c4c506ba60b3476eec0fa4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/fonts/pages-icon/Pages-icon.woff?-u69vo5
// module id = 622
// module chunks = 0